"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translations = exports.messages = exports.getMessages = void 0;
var _flat = _interopRequireDefault(require("flat"));
var _messageByCode = require("./constants/messageByCode");
const messages = exports.messages = Object.keys(_messageByCode.messageByCode).reduce((acc, code) => ({
  ...acc,
  en: {
    ...acc.en,
    [code]: _messageByCode.messageByCode[code].en
  },
  zh: {
    ...acc.zh,
    [code]: _messageByCode.messageByCode[code].zh
  }
}), {
  en: {},
  zh: {}
});
const translations = exports.translations = {
  en: (0, _flat.default)(messages.en, {
    safe: true
  }),
  zh: (0, _flat.default)(messages.zh, {
    safe: true
  })
};
const getMessages = locale => key => {
  if (locale === 'en' || locale === 'zh') {
    return translations[locale][key];
  }
  return translations.en[key];
};
exports.getMessages = getMessages;